// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4908":"4f034e44","7536":"795142f2"}[chunkId] + ".css";
};